import { type Route } from 'src/models';

import {
	Dashboard as HomeIcon,
	ListAlt as CourseIcon,
	EventAvailable as ReviewIcon,
	Work as InstitutionIcon,
	People as UserIcon,
} from '@material-ui/icons';

import Home from './Home';
import Institutions from './Institutions';
import Courses from './Courses';
import Course from './Courses/Course';
import CourseEdition from './Courses/CourseEdition';
import SectionEdition from './Courses/CourseEdition/Sections/SectionEdition';
import Users from './Users';
import Exam from './Exam';
import ExamReview from './Exam/ExamReview';
import Reviews from './Reviews';
import Review from './Reviews/Review';

export const privateRoutes: Route[] = [
	{
		path: '/app/home',
		title: 'Inicio',
		icon: HomeIcon,
		component: Home,
		resource: 'Home',
		ability: 'read',
		isMenuItem: true,
		rights: ['Admin', 'Institution'],
	},
	{
		path: '/app/courses',
		title: 'Cursos',
		icon: CourseIcon,
		component: Courses,
		resource: 'Home',
		ability: 'read',
		isMenuItem: true,
		rights: ['User', 'Admin', 'Institution'],
	},
	{
		path: '/app/courses/:courseId',
		component: Course,
		resource: 'Courses',
		ability: 'read',
		isMenuItem: false,
		rights: ['User'],
	},
	{
		path: '/app/courses/edit/:courseId',
		component: CourseEdition,
		resource: 'Courses',
		ability: 'update',
		isMenuItem: false,
		rights: ['Admin', 'Institution'],
	},
	{
		path: '/app/courses/edit/:courseId/section/:sectionId',
		component: SectionEdition,
		resource: 'Courses',
		ability: 'update',
		isMenuItem: false,
		rights: ['Admin', 'Institution'],
	},
	{
		path: '/app/courses/exam/:courseId',
		component: Exam,
		resource: 'Courses',
		ability: 'read',
		isMenuItem: false,
		rights: ['User'],
	},
	{
		path: '/app/courses/exam/review/:courseId/:userId',
		component: ExamReview,
		resource: 'Courses',
		ability: 'read',
		isMenuItem: false,
		rights: ['User'],
	},
	{
		path: '/app/courses/exam/:courseId/:sectionId',
		component: Exam,
		resource: 'Courses',
		ability: 'read',
		isMenuItem: false,
		rights: ['User'],
	},
	{
		path: '/app/reviews',
		title: 'Revisión',
		icon: ReviewIcon,
		component: Reviews,
		resource: 'Reviews',
		ability: 'read',
		isMenuItem: true,
		rights: ['Admin'],
	},
	{
		path: '/app/reviews/:courseId/:userId',
		component: Review,
		resource: 'Reviews',
		ability: 'read',
		isMenuItem: false,
		rights: ['Admin'],
	},
	{
		path: '/app/institutions',
		title: 'Instituciones',
		icon: InstitutionIcon,
		component: Institutions,
		resource: 'Home',
		ability: 'read',
		isMenuItem: true,
		rights: ['Admin'],
	},
	{
		path: '/app/users',
		title: 'Usuarios',
		icon: UserIcon,
		component: Users,
		resource: 'Home',
		ability: 'read',
		isMenuItem: true,
		rights: ['Admin', 'Institution'],
	},
];
